import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { NamespaceConsumer, NamespaceShape, withNamespace } from '@ux/namespace-component';
import Link from '@ux/link';
import { getCurrentHref } from './util';
import { golf, breakpoints } from './enums';

class ContactUs extends NamespaceConsumer {
  constructor(props) {
    super(...arguments);

    this.imageId = Math.floor(Math.random() * (6 - 1)) + 1;
    this.currentHref = getCurrentHref(props.currentHref, this.isBrowser, this.getDocumentLocation());
  }

  componentDidMount() {
    this.breakpoint(...breakpoints);
  }

  componentWillUnmount() {
    this.breakup();
  }

  getDocumentLocation() {
    if (typeof window !== 'undefined') {
      return document && document.location && document.location.href;
    }
    return null;
  }

  render() {
    const { intl, urls, app } = this.props;
    const isNotDesktop = (['mobile', 'phablet', 'tablet'].indexOf(this.state.breakpoint) !== -1);

    let contactUsUrl = urls && urls.helpCenterContactUs && urls.helpCenterContactUs.href;
    if (app === 'community') {
      contactUsUrl = urls && urls.contactUs && urls.contactUs.href;
    }
    const cdnUrl = urls && urls.cdn && urls.cdn.href;
    const isActive = contactUsUrl === this.currentHref;

    const contactImage = `${cdnUrl}dc-assets/help-header/v1/img/contact${this.imageId}.jpg`;
    const highlightClassNames = this.namespace(this.classNames('help-contact-us-highlight', {
      active: isActive
    }));

    return (
      <div className={ this.namespace('help-contact-us') }>
        <Link
          className={ this.namespace('help-contact-us-link') }
          href={ contactUsUrl }
        >
          <div className={ this.namespace('help-contact-us-image') }>
            <img src={ contactImage } alt={ intl.formatMessage({ id: isNotDesktop ? golf.contactUs : golf.contactUs247 }) } />
          </div>
          <div className={ this.namespace('help-contact-us-link-container') }>
            <FormattedMessage id={ isNotDesktop ? golf.contactUs : golf.contactUs247 } />
            <div className={ highlightClassNames } role='presentation'>&nbsp;</div>
          </div>
        </Link>
      </div>

    );
  }
}

ContactUs.propTypes = {
  ...NamespaceShape,
  urls: PropTypes.object.isRequired,
  currentHref: PropTypes.string,
  app: PropTypes.string
};

export default withNamespace(injectIntl(ContactUs));
